export default "__VITE_ASSET__CYcxePe1__"